export default __webpack_public_path__ + "static/media/p1.f22a94c8.jpg";